/*       */

import { gql } from '@apollo/client';
import loadWorkspaceDetailsCommonQuery from 'graphql/workspaces/loadWorkspaceDetailsCommonQuery';

export default gql`
    mutation removeWorkspaceResourceMutation($id: ID!, $entities: [EntityReferenceInput]!) {
        result: workspaceRemoveEntityResources(id: $id, entities: $entities) {
            ${loadWorkspaceDetailsCommonQuery}
        }
    }
`;
